<template>

  <div id="HearingQuestions">
    <HearingSteps current-step="Questions" :dot-count="questions.length" :currentDot="currQuestion"></HearingSteps>
    <div id="loading-spinner" v-show="!loaded" ><icon name="spinner" pulse></icon></div>
    <div id="question" v-show="loaded">
      <div class="title">{{ currTitle }}</div>
      <v-layout row wrap justify-center align-center >
        <v-flex id="first-btn" sm4 xs8 style="margin-left: 50px">
          <v-btn block class="question-btn" @click="answerQuestion(1)" >{{ yes }} > </v-btn>
        </v-flex>
        <v-flex sm4 xs8>
          <v-btn block class="question-btn" @click="answerQuestion(0)" >{{ no }} > </v-btn>
        </v-flex>
      </v-layout>
      <div class="clearfix"></div>
    </div>
  </div>

</template>

<script>
  import HearingSteps from './steps.vue';
export default {
    name: 'HearingQuestions',

    components: {
        HearingSteps
    },
    mounted() {
        let self = this;
        self.axios.get(ApibaseUrl+"api/v1/hearing_questions").then((response) => {
            self.questions = response.data.result;
            self.showQuestion();
            self.loaded = true;
        })
    },
    data () {
      return {
          loaded: false,
          yes: 'بلی',
          no: 'نه',
          questions:{},
          currQuestion:1,
          currTitle:'',
          answers : [],
      }
    },
    methods:{
        showQuestion(){
            //console.log(this.questions[this.currQuestion]);
            this.currTitle = this.questions[this.currQuestion-1].title;

        },
        answerQuestion(answer){
            //console.log(this.currQuestion , this.questions.length , this.currQuestion < this.questions.length);

            this.answers[this.questions[this.currQuestion-1].id] = {
                'question':this.questions[this.currQuestion-1].id,
                'answer':answer
            };

            if(this.currQuestion < this.questions.length){
                this.currQuestion++;
                this.showQuestion();
            }
            else {
                this.loaded = false;
                this.nextStep();
            }
        },
        nextStep(){
            // save Question Answers
            window.questionsAnswer = this.answers;
            //console.log(this.$parent,);
            this.$parent.$router.replace('/hearing-calibration');
            //console.log("go next Step!",window.questionsAnswer);
        }
    }
}
</script>

<style scoped>
  #question{
    margin: 40px 0;
    padding: 0 10px 30px;
  }
  #loading-spinner{
    padding: 15px;
    font-size: 48px;
    margin: 0 auto;
    width: 100%;
    text-align: center;
  }
  #question .title{
    width: 100%;
    margin: 0 auto 40px;
    text-align: center;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 30px;
  }
  #question .question-btn{
    text-align: center;
    cursor: pointer;
    border: none;
    margin: 0 auto 20px;
    padding-top: 12px;
    padding-bottom: 10px;
    display: inline-block;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 599px){

    #first-btn{
      margin: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingQuestions.vue